import { MdsIcon } from "@/design-system/components/icon";
import styled from "@emotion/styled";
import { Checkbox, CheckboxGroup } from "react-aria-components";

export const StyledCheckbox = styled(Checkbox)`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  &[data-disabled] {
    cursor: default;
    opacity: 0.5;
  }
`;

export const StyledIndicator = styled.div`
  padding: ${({ theme }) => theme.spacing.sm};

  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  [data-focus-visible] & {
    outline: 2px solid ${({ theme }) => theme.colors.mblue.x200};
    outline-offset: 2px;
  }
`;

export const StyledCheckboxGroup = styled(CheckboxGroup)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};

  [slot="label"] {
    font-weight: ${({ theme }) => theme.fontWeights.semiBold};
    font-size: ${({ theme }) => theme.fontSizes.small};
    margin-bottom: ${({ theme }) => theme.spacing.xs};
  }

  [slot="description"] {
    font-size: ${({ theme }) => theme.fontSizes.xsmall};
    color: ${({ theme }) => theme.colors.grey.x400};
    margin-bottom: ${({ theme }) => theme.spacing.xs};
  }

  [slot="errorMessage"] {
    font-size: ${({ theme }) => theme.fontSizes.xsmall};
    color: ${({ theme }) => theme.colors.red.x500};
    margin-top: ${({ theme }) => theme.spacing.xs};
  }
`;

export const StyledCheckboxIcon = styled(MdsIcon)<{ isSelected: boolean }>`
  width: 16px;
  height: 16px;

  svg {
    width: 16px;
    height: 16px;
    transition: all 200ms;

    color: ${({ theme, isSelected }) =>
      isSelected ? theme.colors.icon.selected : theme.colors.text.secondary};

    /* Size adjustment to match screenshots */
    width: 16px;
    height: 16px;
  }
`;
